import React, { useState } from "react";
import { useBaseList } from "../../components/fx";
import { useUserListStore } from "../../controllers/UserListController";
import { shallow } from "zustand/shallow";

const Users = () => {
    const { confirmResendInvite } = useUserListStore((state: any) =>
    ({
        confirmResendInvite: state.confirmResendInvite
    }), shallow);

    const renderResendInviteEvent = (action: any, row: any) => {
        return <span title="Resend Invite" className="m-right-2 pointer resposnive-button text-primary font-13" onClick={() => confirmResendInvite(row)}>
            Resend Invite
        </span>
    }

    const customActionMap: any = {
        resendinvite: renderResendInviteEvent
    }

    const renderDisableValue = ({ row, fieldDef, index }: any) => {
        return <span title={`${row.isDisabled ? "Yes" : "No"}`}>{row.isDisabled ? "Yes" : "No"}</span>
    }

    const fieldTemplates: any = {
        disableValue: renderDisableValue
    }

    const { renderList } = useBaseList({ storeHook: useUserListStore, formRoute: '/user', customActionMap, fieldTemplates });

    return (
        <>
            {renderList()}
        </>
    );
}

export default Users;
